/* eslint-disable react/destructuring-assignment */
import React, { SVGProps } from 'react';

function CustomDropdownCaretIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M8.00001 9.91334L13.02 4.89334C13.1533 4.76 13.3133 4.69334 13.4933 4.7C13.6733 4.7 13.8333 4.77334 13.9667 4.90667C14.1 5.04 14.1667 5.2 14.1667 5.38C14.1667 5.56 14.1 5.72 13.9667 5.85334L8.85334 10.96C8.73334 11.08 8.60001 11.1667 8.44667 11.2267C8.30001 11.2867 8.14667 11.3133 8.00001 11.3133C7.85334 11.3133 7.70001 11.2867 7.55334 11.2267C7.40667 11.1667 7.26667 11.08 7.14667 10.96L2.02667 5.83334C1.89334 5.7 1.82667 5.54667 1.83334 5.36667C1.83334 5.18667 1.90667 5.03334 2.04001 4.9C2.17334 4.76667 2.33334 4.7 2.51334 4.7C2.69334 4.7 2.85334 4.76667 2.98667 4.9L8.00001 9.91334Z" fill="currentColor" />
    </svg>
  );
}

export default CustomDropdownCaretIcon;
